export const HUBUP_ANNUARY_CATEGORIES = [
  'Productivité',
  'Paiement',
  'Marketing',
  'Analytics',
  'Design',
  'Développement',
  'Support client',
  'Gestion de projet',
  'Communication',
  'Base de données',
  'Déploiement',
  'Sécurité',
  'RH & Recrutement',
  'Finance',
  'Associations',
  'BDE',
  'Sports',
  'Autre',
];

export const annuaryCategorySelectClass =
  'w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring';

export function isKnownAnnuaryCategory(value) {
  return HUBUP_ANNUARY_CATEGORIES.includes(String(value ?? '').trim());
}
